import { PermissionEnum } from '@creditsights/api-ui-web';
import { SnippetType } from '../../models';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import useFetchUserProfile from '../profile/useFetchUserProfile';
import useFetchSnippet from '../snippets/useFetchSnippet';

interface useFetchForPrintResult {
  userFullName: string;
  disclaimer: string | undefined;
  customLogoUrl: string | undefined;
  customSupportText: string | undefined;
  isContentReadyForPrint: boolean;
  redistributionAllowed: boolean;
}

const useFetchForPrint = (imagesLoaded = true): useFetchForPrintResult => {
  const { data: userPermissions } = useFetchUserPermissions();
  const { data: profile, isLoading: isLoadingUserProfile } = useFetchUserProfile();
  const { isLoading: isFooterDisclaimerLoading, data: footerSnippet } = useFetchSnippet(
    SnippetType.BOILER_PLATE,
    'footer'
  );
  const { isLoading: isCustomLogoLoading, data: logoSnippet } = useFetchSnippet(SnippetType.BOILER_PLATE, 'logo_site');
  const { isLoading: isCustomAccountSupport, data: accountSupport } = useFetchSnippet(
    SnippetType.BOILER_PLATE,
    'account_support'
  );

  return {
    userFullName: profile ? `${profile.firstName} ${profile.lastName}`.trim() : '',
    disclaimer: footerSnippet?.body,
    customLogoUrl: logoSnippet?.image?.url,
    customSupportText: accountSupport?.body,
    redistributionAllowed: userPermissions?.permissions.includes(PermissionEnum.REDISTRIBUTION_ALLOWED) ?? false,
    isContentReadyForPrint:
      imagesLoaded &&
      !isLoadingUserProfile &&
      !isFooterDisclaimerLoading &&
      !isCustomLogoLoading &&
      !isCustomAccountSupport,
  };
};

export default useFetchForPrint;
